import React, { useEffect, useState } from 'react';
import { PageContainer, PageContent } from '../component/Containers/Containers';
import styled from 'styled-components';
import logo from '../assets/ctcradiologo.svg';
import { ContentText } from '../component/PageComponents/InfoComponents/InfoComponents';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setIsLoadingTo } from '../store/features/adminSlice';
/**
 * box container which aligns and holds the content
 * @returns {HTMLSectionElement}
 */
const AboutBox = styled.section`
  width: 100%;
  height: 100%;
  padding-right: 30px;
  margin-right: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

/**
 * generates the main column for the layout
 * @returns {HTMLDivElement}
 */
const CenterColumn = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AboutButton = styled.button`
  position: relative;
  margin-top: 20px;
  width: 250px;
  height: 40px;
  outline: 0;
  background: #003876;
  border: none;
  border-radius: 8px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  overflow: hidden;
  transition: all ease-in 300ms;

  &:hover {
    background-color: #0b5ba3;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.6);
  }

  @media (max-width: 565px) {
    margin-top: 10px;
  }
`;

const Row = styled.div`
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 30px;
`;

/**
 * @component
 * returns the about page accessed by the dropdown menu, and re routes to the login page.
 * @returns {void}
 */
const About = () => {
  let history = useHistory();
  const isLoggedIn = useSelector((state) => state.admin.isLoggedIn);
  const dispatch = useDispatch();

  const highlightIcon = (e) => {
    e.target.style.color = '#0b5ba3';
  };

  const unHighlightIcon = (e) => {
    e.target.style.color = '#003876';
  };

  /**
   * re routes user to the login page
   * @returns {void}
   */
  const takeToLogin = () => {
    history.push('/login');
  };

  useEffect(() => {
    dispatch(setIsLoadingTo(false));
  }, [dispatch]);

  return (
    <PageContainer>
      <PageContent>
        <AboutBox>
          <CenterColumn>
            <img
              alt="ctc radio logo"
              src={logo}
              width="125px"
              height="125px"
              style={{ paddingRight: '30px', marginBottom: '30px' }}
            />

            <ContentText
              style={{
                fontSize: '1.1rem',
                fontWeight: '600',
                textAlign: 'center',
                margin: '0',
              }}>
              Acerca del desarollador
            </ContentText>
            <ContentText
              style={{
                textAlign: 'center',
                fontSize: '0.9rem',
                marginBottom: '8px',
              }}>
              Centros Tecnológicos Comunitarios ©
            </ContentText>
            <ContentText
              style={{
                textAlign: 'center',
                fontSize: '0.9rem',
                marginBottom: '13px',
                marginTop: '0',
              }}>
              C/ Pedro Henríquez Ureña, #12, Gazcue, Santo Domingo, República
              Dominicana.
            </ContentText>
            <ContentText
              style={{
                textAlign: 'center',
                fontSize: '0.9rem',
                marginBottom: '13px',
                marginTop: '0',
              }}>
              Contacto: colmena.desarollo@ctc.edu.do; lenin.cepeda@ctc.edu.do;
            </ContentText>

            <ContentText
              style={{
                fontSize: '1.1rem',
                fontWeight: '600',
                textAlign: 'center',
                marginTop: '10px',
              }}>
              Sobre la aplicacion
            </ContentText>
            <ContentText
              style={{
                textAlign: 'center',
                fontSize: '0.9rem',
                marginTop: '0',
                marginBottom: '10px',
              }}>
              versión 1.0
            </ContentText>
            <Row>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: '40px',
                }}>
                <i
                  onMouseEnter={(e) => highlightIcon(e)}
                  onMouseLeave={(e) => unHighlightIcon(e)}
                  style={{
                    display: 'block',
                    margin: '10px',
                    fontSize: '20px',
                    color: '#003876',
                    paddingTop: '3px',
                    cursor: 'pointer',
                  }}
                  className="fab fa-google-play"></i>

                <i
                  onMouseEnter={(e) => highlightIcon(e)}
                  onMouseLeave={(e) => unHighlightIcon(e)}
                  style={{
                    display: 'block',
                    margin: '10px',
                    fontSize: '25px',
                    color: '#003876',
                    cursor: 'pointer',
                  }}
                  className="fab fa-apple"></i>
              </div>
            </Row>
            {isLoggedIn ? null : (
              <>
                <AboutButton onClick={takeToLogin}>acceder</AboutButton>
                <ContentText
                  style={{
                    fontWeight: '400',
                    textAlign: 'center',
                    margin: '0',
                    fontSize: '0.9rem',
                  }}>
                  Acceder como administrador.
                </ContentText>
              </>
            )}
          </CenterColumn>
        </AboutBox>
      </PageContent>
    </PageContainer>
  );
};

export default About;
